// json
export const jsonSerializer = {
	type: ["application/json"],
	serialize (data) {
		return JSON.stringify(data)
	}
}
// form-data
export const formDataSerializer = {
	type: ["multipart/form-data"],
	serialize (data) {
		const flatten = (formData, currentData, parentKey, key) => {
			const fullPathKey = parentKey ? `${parentKey}[${key}]` : key
			const value = currentData

			if (value == null) return formData

			// 配列の場合、各要素に対し再帰処理する
			if (value instanceof Array) {
				value.forEach((childValue, index) => flatten(formData, childValue, fullPathKey, index))
			// オブジェクトがネストしているの場合、再帰処理する
			} else if (typeof value === "object" && !(value instanceof File)) {
				Object.keys(value).forEach(childKey => flatten(formData, value[childKey], fullPathKey, childKey))
			} else if (value != null) {
				formData.set(fullPathKey, value)
			}
			return formData
		}
		return Object.keys(data).reduce((formData, key) => flatten(formData, data[key], "", key), new FormData())
	}
}
// xxx-form-urlencoded
export const urlencodedSerializer = {
	type: ["application/x-www-form-urlencoded"],
	serialize (data) {
		const flatten = (formData, currentData, parentKey, key) => {
			const fullPathKey = parentKey ? `${parentKey}.${key}` : key
			const value = currentData[key]
			if (Array.isArray(value)) {
				value.forEach((item, index) => {
					if (item instanceof Object) {
						Object.keys(item).forEach(childKey => flatten(formData, item, `${fullPathKey}[${index}]`, childKey))
					} else {
						formData.append(`${fullPathKey}[${index}]`, item)
					}
				})
			} else if (value instanceof Object) {
				Object.keys(value).forEach(childKey => flatten(formData, value, fullPathKey, childKey))
			} else if (value != null) {
				formData.append(fullPathKey, value)
			}
			return formData
		}
		return Object.keys(data).reduce((formData, key) => flatten(formData, data, "", key), new URLSearchParams())
	}
}
